import React from 'react';
import ReactDom from 'react-dom';

import ErrorBoundary from '../Components/ErrorBoundary/index.jsx';
import PagedData from '../Components/PagedData/index.jsx';
import ResearchReportsList from '../Components/ResearchReportsList/index.jsx';
import ResearchReportsFilters from '../Components/ResearchReportsFilters/index.jsx';
import ShowLocked from '../Components/ShowLocked/index.jsx';

import API from '../Services/ResearchReports/index.jsx';


export default function(document) {
  var element = document.getElementById('cs-research-reports');

  if (element) {
    var categories = element.dataset.categories;
    var showLocked = Boolean(element.dataset.showLocked);
    var showLockedUi = Boolean(element.dataset.showLockedUi);
    var limit = element.dataset.limit;

    if (categories) {
      categories = categories.split(',');
    } else {
      categories = [];
    }
    if (limit) {
      limit = parseInt(limit);
    }

    var api = new API(categories, limit, '');
    api.showLocked(showLocked);
    var WrappedComponent = PagedData(ResearchReportsList, api);

    var output = [];
    if (! (categories.length || limit)) {
      output.push(
        <ResearchReportsFilters key="filters" api={api} />
      );
    }
    if (showLockedUi) {
      output.push(
        <ShowLocked key="show-locked" showLocked={showLocked} apiService={api} />
      );
    }
    output.push(
      <WrappedComponent key="component" />
    );


    ReactDom.render(
      <ErrorBoundary>
        {output}
      </ErrorBoundary>,
      element
    );
  }
};

